<!-- Static summary (no collapsible body) -->
<div class="!m-0 max-w-full min-w-0 !rounded-none !shadow-none">
  <div
    class="!bg-gray box-border !shadow-none !px-3 !h-20 flex w-full min-w-0 max-w-full items-center overflow-x-clip"
    [class]="direction"
    >
    <div class="min-w-0 max-w-full flex-1 basis-0">
      <div
        class="flex max-w-full min-w-0 justify-between gap-2"
        (click)="focusLocationEvent.emit(section.departure?.place?.location)"
        >
        <div class="flex min-w-0 flex-1 basis-0 items-center gap-2">
          <ng-icon
            name="car"
            class="section-icon shrink-0 text-2xl relative border-2 border-solid border-primary p-2"
            [ngClass]="{
              'section-icon--first': index == 0,
              'section-icon--last': index == length - 1
            }"
            style="border-radius: 50%"
            />

            <span class="flex flex-col gap-2 min-w-0">
              <span class="font-normal text-sm text-[#0C3058]">{{
                travelByCarText
              }}</span>
            </span>
          </div>

          <span class="shrink-0 ps-1 tabular-nums text-[#0C3058]">{{
            section.departure.hourTimeString | hour
          }}</span>
        </div>
      </div>
    </div>
  </div>

  @if (!!section.actions && !!section.actions.length) {
    <mat-expansion-panel
      class="!m-0 !rounded-none !bg-transparent !shadow-none"
      [class]="direction"
      >
      <mat-expansion-panel-header class="!bg-transparent !shadow-none !px-6 !h-12">
        <mat-panel-title class="!m-0 text-primary !gap-6 !px-2">
          <mat-divider
            [vertical]="true"
            color="primary"
            class="!border-r-solid !border-r-primary h-full"
            style="margin-right: 1px; margin-left: 1px"
            />
            <div class="flex items-center h-full pt-2">
              <span class="flex text-primary gap-2 items-center">
                <span class="text-sm font-normal text-[#0068F5]">{{
                  calculatedSectionDurationText
                }}</span>
                <span class="text-subText text-sm" aria-hidden="true">•</span>
                <span class="text-sm font-normal text-[#0068F5]"
                  >{{ calcSectionDistance() }}
                  {{ distanceUnitShortText }}</span
                  >
                </span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="flex flex-col gap-2 px-8">
            @for (
              action of section.actions; track
              action; let actionIndex = $index; let isLastAction = $last) {
              <div
                class="flex justify-between"
                >
                <div class="flex gap-5 items-center">
                  <app-stop-indicator
                    [isLastStop]="isLastAction"
                    class="!h-full"
                    topLineClass="!h-1/2"
                    bottomLineClass="!h-1/2"
                    />
                    <span class="stop-name text-[#0C3058]">{{ action.instruction }}</span>
                  </div>
                </div>
              }
            </div>
            <!-- <mat-divider
            [vertical]="true"
            color="primary"
            class="h-4 !border-solid !border-t-0 !border-b-0"
    [ngClass]="{
      ' !border-r-primary': direction === 'rtl',
      '!border-l-2 !border-l-primary': direction === 'ltr'
    }"
    [ngStyle]="
      direction === 'rtl'
        ? { 'margin-right': 'calc(2rem + 1px)' }
        : { 'margin-left': 'calc(2rem + 1px)' }
    "
            /> -->
          </mat-expansion-panel>
        }
